export default "__VITE_PUBLIC_ASSET__7d0bbfcd__"